import { createFileRoute } from '@tanstack/react-router'
import ContactLinks from 'Contact/components/Contact/Sections/ContactLinks'

export const Route = createFileRoute('/contact/$contactId/links')({
    component: ContactLinks,
})
